module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/website-white-329f25d1e06e71945b52098902788da2.svg";